// import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken () {
  return sessionStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function setToken (token) {
  sessionStorage.setItem(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken () {
  sessionStorage.removeItem(TokenKey)
  // return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/tools/auth.js